import React from "react";

export const TextArea = ({
  name,
  value,
  onChage,
  rows = 6,
  label,
  autoComplete,
  required = false,
  placeholder,
  className = "",
  errorMessage,
}: Props) => {
  const resolvedClass = `${staticClass} ${className}`;

  return (
    <div className="flex-col space-y-1">
      <label className="block text-sm font-medium text-gray-700">{label}</label>
      <textarea
        name={name}
        autoComplete={autoComplete}
        required={required}
        placeholder={placeholder}
        className={resolvedClass}
        value={value}
        onChange={onChage}
        rows={rows}
      />
      {errorMessage && (
        <p className="mt-1 text-red-500 text-xs italic">
          Please fill out this field.
        </p>
      )}
    </div>
  );
};

interface Props {
  name: string;
  value: string;
  onChage: React.ChangeEventHandler<HTMLTextAreaElement> | undefined;
  rows?: number;
  label?: string;
  autoComplete?: string;
  required?: boolean;
  placeholder?: string;
  className?: string;
  errorMessage?: string;
}

const staticClass = `
    shadow-sm focus:ring-indigo-500 focus:border-indigo-500 px-3 py-2
    block w-full sm:text-sm border border-gray-300 rounded-md
`;
